module.exports = __webpack_public_path__ + "src/img/search.2172bf1b.png";